console.log('custom loaded')

//reordering newsletter and social
jQuery.fn.swapWith = function(to) {
return this.each(function() {
  var copy_to = $(to).clone(true);
  var copy_from = $(this).clone(true);
  $(to).replaceWith(copy_from);
  $(this).replaceWith(copy_to);
});
};
jQuery(function() {
jQuery('body').on('click', 'a', function(e) {
  
  e.preventDefault()
  
  if (jQuery(e.target).is('a')) {
    var element = jQuery(e.target);
  } else {
    var element = jQuery(e.target).closest('a')
  }
  var href = element.attr('href')

  console.log('clicked href:'+href)
  
  
  if(element.attr('data-item') == 'parent') {
    console.log('drawer clicked')
  } else if(href && (href.indexOf('http') > -1 || href.indexOf('https') > -1 || element.hasClass('logo-list__item'))) {
    e.target.target = '_blank';
    window.open(href, '_blank').focus();
  } else {
    window.open(href,"_self")
  }
});


//SAM246
//jQuery('.collection-item__image-wrapper').removeAttr('href')

//reordering newsletter and social
$('.footer__group--social').swapWith('.footer__group--newsletter');


/*add button to Mr.Kate*/
  jQuery('#shopify-section-template--17491432734873__871a4c06-30a2-4bc4-9821-9d422caa84a49821-9d422caa84a4 .image-with-text__subheading').after('<div style="margin: 0 auto; text-align:center;"><a href="https://www.realrooms.com/collections/mr-kate" target="_blank" class="image-with-text__button fs-body-base btn btn--primary btn--medium animation-fade-up-reveal" style="text-transform: capitalize;display: inline-block; line-height: 20px;text-align: center; border:2px solid #333; margin: 25px  5px 10px 5px; padding:13px 40px"><span style="font-size:13px; display:block;font-weight:normal">'+shop+'</span> RealRooms</a><a href="https://shop.mrkate.com/" target="_blank" class="image-with-text__button fs-body-base btn btn--default btn--medium animation-fade-up-reveal" style="text-transform: capitalize;display: inline-block; line-height: 20px;text-align: center; border:2px solid #333; margin: 25px 5px 10px 0; padding:13px 40px"><span style="font-size:13px; display:block;font-weight:normal">'+shop+'</span> <b>Mr. Kate</b></a></div>')


/*PARTY-894*/

/*add button to Novogratz*/
  jQuery('#shopify-section-template--17491432898713__871a4c06-30a2-4bc4-9821-9d422caa84a4 .image-with-text__subheading').after('<div ><a href="https://www.realrooms.com/collections/novogratz" target="_blank" class="image-with-text__button fs-body-base btn btn--primary btn--medium animation-fade-up-reveal" style="text-transform: capitalize;display: inline-block; line-height: 20px;text-align: center; border:2px solid #333; margin: 25px  5px 10px 5px; padding:13px 35px"><span style="font-size:13px; display:block;font-weight:normal">'+shop+'</span> RealRooms</a></div>')
  //<a href="https://www.shopthenovogratz.com/" target="_blank" class="image-with-text__button fs-body-base btn btn--default btn--medium animation-fade-up-reveal" style="text-transform: capitalize;display: inline-block; line-height: 20px;text-align: center; border:2px solid #333; margin: 25px  5px 10px 0; padding:13px 35px"><span style="font-size:13px; display:block;font-weight:normal">'+shop+'</span> <b>The Novogratz</b></a>


/*add button to CosmoLiving*/
  jQuery('#shopify-section-template--17491432210585__871a4c06-30a2-4bc4-9821-9d422caa84a4 .image-with-text__subheading').after('<a href="https://www.realrooms.com/collections/cosmoliving-by-cosmopolitan" target="_blank" class="image-with-text__button fs-body-base btn btn--primary btn--medium animation-fade-up-reveal" >'+shop+' CosmoLiving</a>')

/*add button to Little Seeds*/
//  jQuery('#shopify-section-template--17491432669337__871a4c06-30a2-4bc4-9821-9d422caa84a4 .image-with-text__subheading').after('<a href="https://www.realrooms.com/collections/little-seeds" target="_blank" class="image-with-text__button fs-body-base btn btn--primary btn--medium animation-fade-up-reveal" >'+shop+' Little Seeds</a>')

/*add button to Ameriwood*/
  jQuery('#shopify-section-template--17491431817369__871a4c06-30a2-4bc4-9821-9d422caa84a4 .image-with-text__subheading').after('<a href="https://www.realrooms.com/collections/ameriwood-home" target="_blank" class="image-with-text__button fs-body-base btn btn--primary btn--medium animation-fade-up-reveal" >'+shopameriwoodhome+' </a>')

    
//Add a 2nd button next to the one below, that says Ameriwood Home  (Divisions page), and link it to http://Ameriwoodhome.com Shopify page: (https://admin.shopify.com/store/dorelhomefurnishings/themes/132527718553/editor?customCss=true&previewPath=%2Fpages%2Fdivisions)
  jQuery('#shopify-section-template--17491431817369__871a4c06-30a2-4bc4-9821-9d422caa84a4 .image-with-text__button').after('<a href="https://www.ameriwoodhome.com" target="_blank" class="image-with-text__button fs-body-base btn btn--primary btn--medium animation-fade-up-reveal" style="margin-top:5px;" >AmeriwoodHome.com</a>')


/*add button to DHP*/
  jQuery('#shopify-section-template--17491432407193__871a4c06-30a2-4bc4-9821-9d422caa84a4 .image-with-text__subheading').after('<a href="https://www.realrooms.com/collections/dhp" target="_blank" class="image-with-text__button fs-body-base btn btn--primary btn--medium animation-fade-up-reveal" >'+shop+' DHP</a>')

/*add button to Cosco*/
  jQuery('#shopify-section-template--17491432145049__871a4c06-30a2-4bc4-9821-9d422caa84a4 .image-with-text__subheading').after('<a href="https://www.realrooms.com/collections/cosco" target="_blank" class="image-with-text__button fs-body-base btn btn--primary btn--medium animation-fade-up-reveal" >'+shop+' Cosco</a>')

/*add button to Real Rooms*/
  jQuery('#shopify-section-template--17491433259161__871a4c06-30a2-4bc4-9821-9d422caa84a4 .image-with-text__subheading').after('<a href="https://www.realrooms.com/collections/realrooms" target="_blank" class="image-with-text__button fs-body-base btn btn--primary btn--medium animation-fade-up-reveal" >'+shop+' RealRooms</a>')

/*add button to Baby Relax NO LONGER ON SITE*/
jQuery('#shopify-section-template--16214056239257__871a4c06-30a2-4bc4-9821-9d422caa84a4 .image-with-text__subheading').after('<a href="https://www.realrooms.com/collections/baby-relax" target="_blank" class="image-with-text__button fs-body-base btn btn--primary btn--medium animation-fade-up-reveal" >'+shop+' Baby Relax</a>')

/*add button to Signature Sleep*/
  jQuery('#shopify-section-template--17491433390233__871a4c06-30a2-4bc4-9821-9d422caa84a4 .image-with-text__subheading').after('<a href="https://www.realrooms.com/collections/signature-sleep" target="_blank" class="image-with-text__button fs-body-base btn btn--primary btn--medium animation-fade-up-reveal" >'+shop+' Signature Sleep</a>')

/*add button to Ren Home*/
  jQuery('#shopify-section-template--17491433291929__871a4c06-30a2-4bc4-9821-9d422caa84a4 .image-with-text__subheading').after('<a href="https://www.realrooms.com/collections/ren-home" target="_blank" class="image-with-text__button fs-body-base btn btn--primary btn--medium animation-fade-up-reveal" >'+shop+' Ren Home</a>')

/*add button to SystemBuild*/
  jQuery('#shopify-section-template--17491433423001__871a4c06-30a2-4bc4-9821-9d422caa84a4 .image-with-text__subheading').after('<a href="https://www.realrooms.com/collections/system-build" target="_blank" class="image-with-text__button fs-body-base btn btn--primary btn--medium animation-fade-up-reveal" >'+shop+' Systembuild</a>')

/*add button to NTense*/
  jQuery('#shopify-section-template--17491432997017__871a4c06-30a2-4bc4-9821-9d422caa84a4 .image-with-text__subheading').after('<a href="https://www.realrooms.com/collections/ntense" target="_blank" class="image-with-text__button fs-body-base btn btn--primary btn--medium animation-fade-up-reveal" >'+shop+' NTense</a>')

/*add button to Alphason*/
//jQuery('#shopify-section-template--17491431686297__871a4c06-30a2-4bc4-9821-9d422caa84a4 .image-with-text__subheading').after('<a href="https://www.realrooms.com/collections/mr-kate" target="_blank" class="image-with-text__button fs-body-base btn btn--primary btn--medium animation-fade-up-reveal" >'+shop+' Alphason</a>')

/*add button to Bertini NO LONGER ON SITE */
//jQuery('#shopify-section-template--16080771612825__871a4c06-30a2-4bc4-9821-9d422caa84a4 .image-with-text__subheading').after('<a href="https://www.realrooms.com/collections/mr-kate" target="_blank" class="image-with-text__button fs-body-base btn btn--primary btn--medium animation-fade-up-reveal" >'+shop+' Bertini</a>')

/*add button to Ollie & Hutch*/
  jQuery('#shopify-section-template--17491433062553__871a4c06-30a2-4bc4-9821-9d422caa84a4 .image-with-text__subheading').after('<a href="https://www.realrooms.com/collections/pets" target="_blank" class="image-with-text__button fs-body-base btn btn--primary btn--medium animation-fade-up-reveal" >'+shop+' Ollie & Hutch</a>')

/*add button to Cortney’s Collection*/
  jQuery('#shopify-section-template--17491432079513__871a4c06-30a2-4bc4-9821-9d422caa84a4-9d422caa84a4 .image-with-text__subheading').after('<a href="https://www.realrooms.com/collections/cortneys-collection" target="_blank" class="image-with-text__button fs-body-base btn btn--primary btn--medium animation-fade-up-reveal" >'+shop+' Cortney’s Collection</a>')

/*add button to Safety1st*/
//jQuery('#shopify-section-template--17491433324697__871a4c06-30a2-4bc4-9821-9d422caa84a4 .image-with-text__subheading').after('<a href="https://www.realrooms.com/collections/mr-kate" target="_blank" class="image-with-text__button fs-body-base btn btn--primary btn--medium animation-fade-up-reveal" >'+shop+' Mr. Kate</a>')



  /*add button to customer service */
  jQuery('#shopify-section-template--17491432276121__image_with_text_PdGtTK p:nth-child(2)').after('<button type="button" onclick="clickbutton()" class="image-with-text__button fs-body-base btn btn--primary btn--medium animation-fade-up-reveal" style="margin-top: 15px;" >Send Us a Message</button>')

})
 var iframe = document.getElementById('launcher');

function clickbutton() {
    // Get the iframe element
   var iframe = document.getElementById('launcher');

    // Access the iframe's document
    var iframeDoc = iframe.contentWindow.document;

    // Find the button with the class 'kFCjbb' inside the iframe
    var button = iframeDoc.querySelector('.kFCjbb');

    // Trigger the click event on the button
    if (button) {
        button.click();
    } else {
        console.log('Button not found');
    }
}